import 'particles.js';

const MOBILE_BREAKPOINT = 781;

const baseConfig = (mode, isMobile) => {
  const dark = mode === 'dark';
  const particleColor = dark
    ? ['#ffffff', '#d7def7', '#9fc3ff', '#8e3cf7', '#3cc1b7']
    : ['#011f3d', '#193857', '#36597d', '#8e3cf7', '#058192'];

  return {
    particles: {
      number: {
        value: isMobile ? 20 : 36,
        density: {
          enable: true,
          value_area: isMobile ? 900 : 1200,
        },
      },
      color: {
        value: particleColor,
      },
      shape: {
        type: 'circle',
      },
      opacity: {
        value: dark ? 0.42 : 0.34,
        random: true,
        anim: {
          enable: true,
          speed: 0.34,
          opacity_min: dark ? 0.12 : 0.1,
          sync: false,
        },
      },
      size: {
        value: 10,
        random: true,
        anim: {
          enable: false,
        },
      },
      line_linked: {
        enable: false,
      },
      move: {
        enable: true,
        speed: isMobile ? 0.4 : 0.6,
        direction: 'none',
        random: true,
        straight: false,
        out_mode: 'bounce',
        bounce: true,
        attract: {
          enable: false,
        },
      },
    },
    interactivity: {
      detect_on: 'canvas',
      events: {
        onhover: {
          enable: false,
        },
        onclick: {
          enable: false,
        },
        resize: true,
      },
    },
    retina_detect: true,
  };
};

const ensureHostId = (host) => {
  if (host.id) {
    return host.id;
  }

  const random = Math.random().toString(36).slice(2, 10);
  host.id = `full-bleed-ribbon-particles-${random}`;
  return host.id;
};

const initRibbon = (ribbon) => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion || window.innerWidth <= MOBILE_BREAKPOINT) {
    return;
  }

  const host = ribbon.querySelector('[data-particles-host]');
  if (!host) {
    return;
  }

  const hostId = ensureHostId(host);
  const mode = ribbon.dataset.particlesMode === 'light' ? 'light' : 'dark';
  const config = baseConfig(mode, false);

  if (typeof window.particlesJS !== 'function') {
    return;
  }

  window.particlesJS(hostId, config);
};

const FullBleedRibbon = () => {
  const ribbons = Array.from(document.querySelectorAll('[data-full-bleed-ribbon]'));
  ribbons.forEach(initRibbon);
};

export default FullBleedRibbon;
